import { ref } from 'vue'

// Browser tab titles: "[Most specific] – [Section] | The Channel Standard".
export const BRAND = 'The Channel Standard'
const SEPARATOR = ' – '
const MAX_PART = 40

type Part = string | null | undefined | false

function truncate(part: string): string {
    return part.length > MAX_PART ? `${part.slice(0, MAX_PART - 1).trimEnd()}…` : part
}

export function formatTitle(...parts: Part[]): string {
    const body = parts
        .filter((p): p is string => typeof p === 'string' && p.trim() !== '')
        .map(p => truncate(p.trim()))
        .join(SEPARATOR)
    return body ? `${body} | ${BRAND}` : BRAND
}

// Read by the visually hidden live region in App.vue so screen readers hear
// the new page title after a client-side navigation.
export const routeAnnouncement = ref('')

// Announce each navigation's static title and the first data-aware title that
// replaces it; later in-page changes (e.g. typing a name into an edit form)
// only update the tab, so screen readers aren't flooded.
let refined = false

/** Router: static meta.title on every navigation. */
export function setRouteTitle(...parts: Part[]): void {
    refined = false
    document.title = routeAnnouncement.value = formatTitle(...parts)
}

/** usePageTitle: data-aware title for the current page. */
export function refineTitle(title: string): void {
    document.title = title
    if (!refined) routeAnnouncement.value = title
    refined = true
}
